<template>
  <div class="inline-block" @click.prevent.stop>
    <button type="button" class="btn btn-secondary btn-toggle" :class="{ 'active': this.lValue }"
            data-toggle="button" :aria-pressed="lValue" :title="label" autocomplete="off"
            @click.prevent.stop="onClick">
      <div class="handle" />
    </button><span class="btn-label" style="cursor: pointer;" @click.prevent.stop="onClick">{{ label }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lValue: this.value,
    };
  },
  methods: {
    onClick() {
      this.lValue = !this.lValue;
      this.$emit('input', this.lValue);
    },
  },
  name: 'ToggleButton',
  props: ['label', 'title', 'value'],
};
</script>

<style scoped>
.btn-toggle {
  background: #bdc1c8;
  border: none;
  border-radius: 1.5rem;
  color: #6b7381;
  height: 20px;
  margin: 8px 1rem 8px 4rem;
  padding: 0;
  position: relative;
  width: 3rem;
}
.btn-toggle:focus,
.btn-toggle.focus,
.btn-toggle:focus.active,
.btn-toggle.focus.active {
  outline: none;
}
.btn-toggle:after,
.btn-toggle:before {
  bottom: 0;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 20px;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  transition: opacity 0.25s;
}
.btn-toggle:before {
  content: 'off';
  left: -4rem;
  width: 4rem;
}
.btn-label {
  bottom: 0;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 20px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  transition: opacity 0.25s;
  content: 'watch';
  opacity: 0.5;
  width: 5rem;
}
.btn-toggle.active + .btn-label {
  opacity: 1;
}
.btn-toggle > .handle {
  position: absolute;
  top: 0.1875rem;
  left: 0.1875rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 1.125rem;
  background: #ffffff;
  transition: left 0.25s;
}
.btn-toggle.active {
  background-color: #6b98d0;
  transition: background-color 0.25s;
}
.btn-toggle.active > .handle {
  left: 1.6875rem;
  transition: left 0.25s;
}
.btn-toggle.active:after {
  opacity: 1;
}
.btn-toggle.active:before {
  opacity: 0.5;
}

.inline-block {
  display: inline-block;
}
</style>
